import React from 'react';
import { Typography, Switch } from '@material-ui/core';

export default function EditAvailability({ available, booked, setAvailable, isEditMode, setBooked }) {
  const handleChangeAvailable = (event) => {
    setAvailable(event.target.checked);
  };
  const handleChangeBooked = (event) => {
    setBooked(event.target.checked);
  };

  return (
    <div style={{ display: 'inline-grid' }}>
      <div style={{ alignItems: 'center', display: 'inline-flex', justifyContent: 'space-between' }}>
        <Typography>În stoc - {available ? 'Da' : 'Nu'}</Typography>
        {isEditMode && <Switch checked={available} onChange={handleChangeAvailable} />}
      </div>
      <div style={{ alignItems: 'center', display: 'inline-flex', justifyContent: 'space-between' }}>
        <Typography>Rezervat - {booked ? 'Da' : 'Nu'}</Typography>
        {isEditMode && <Switch checked={booked} onChange={handleChangeBooked} />}
      </div>
    </div>
  );
}
